export { AnalyticsFeatureContextProvider, useAnalyticsFeatureContext } from './analytics-feature-context';
async function importAnalyticsAsync() {
  return import( /* webpackChunkName: "pushpay-analytics" */'./analytics');
}
export async function recordEvent(args) {
  const analyticsModule = await importAnalyticsAsync();
  const analytics = await analyticsModule.getAnalytics();
  return analytics.record(args);
}
export async function updateEndpoint(args) {
  const analyticsModule = await importAnalyticsAsync();
  const analytics = await analyticsModule.getAnalytics();
  return analytics.updateEndpoint(args);
}
export async function getAnalytics() {
  const analyticsModule = await importAnalyticsAsync();
  return analyticsModule.getAnalytics();
}
async function configureAnalytics(config) {
  const analyticsModule = await importAnalyticsAsync();
  analyticsModule.configure(config);
}
export function initializeAnalytics(config) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => configureAnalytics({
      provider: 'AWS',
      ...config
    }));
  } else {
    configureAnalytics({
      provider: 'AWS',
      ...config
    });
  }
}
export default getAnalytics;